<template>
  <div class="page_account_components partI">
    <!-- 新建 -->
    <el-dialog
      :title="createDialogTitle"
      :visible.sync="showCreateDialog"
      width="61rem"
      :before-close="handleDialogClose"
      :close-on-click-modal="false"
      class="dialog_operation_account_create partI"
    >
      <el-form
        :model="createData"
        ref="formCreateAccount"
        label-width="25rem"
        :rules="createData.id ? editRules : createRules"
      >
        <el-form-item label="岗位名称：">
          <div class="pms_name">{{ activeTabLabel }}</div>
        </el-form-item>
        <el-form-item prop="name" label="登录帐号：" v-if="createData.id">
          <el-input v-model="createData.name" disabled></el-input>
        </el-form-item>
        <el-form-item prop="unitName" label="单位简称：" v-if="createData.id">
          <el-input v-model="createData.unitShortName" disabled></el-input>
        </el-form-item>
        <el-form-item prop="unitId" label="单位简称：" v-else>
          <el-select v-model="createData.unitId" placeholder="请选择">
            <el-option
              v-for="item in arrUnitForCreate"
              :key="item.appId"
              :label="item.appShortName"
              :value="item.appId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="重置密码：" v-if="createData.id">
          <el-input class="reset_input" v-model="resetPwd" disabled></el-input>
          <el-button
            type="info"
            class="reset_btn disable"
            v-if="createData.resetPwd"
            disabled
            >已重置</el-button
          >
          <el-button
            type="primary"
            class="reset_btn"
            @click="btbResetPwdClick"
            v-else
            >重置密码</el-button
          >
        </el-form-item>
        <el-form-item prop="nick" label="使用者：">
          <el-input
            v-model.trim="createData.nick"
            placeholder="请输入使用者"
            maxlength="30"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="tel" label="联系方式：">
          <el-input
            v-model="createData.tel"
            placeholder="请输入联系方式"
            maxlength="11"
            @input="
              (v) => {
                this.createData.tel = v.replace(/[^\d]/g, '');
              }
            "
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="enterpriseMobile" label="企业微信号：" v-if="activeType == '3'">
          <el-input
            v-model="createData.enterpriseMobile"
            placeholder="请输入企业微信手机号"
            maxlength="11"
            @input="
              (v) => {
                this.createData.enterpriseMobile = v.replace(/[^\d]/g, '');
              }
            "
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="企业微信二维码："
          prop="coverType"
          class="search_item_a"
          v-if="activeType == '3'"
        >
          <div class="cover_upload_area_b">
            <OSSUpload
              :type="7"
              @fileInfoA="coverFileInfo"
              :imageUrl="this.createData.coverUrl"
              v-if="toShowCover"
            ></OSSUpload>
            <OSSUpload
              :type="7"
              @fileInfoA="coverFileInfo"
              :imageUrl="this.createData.coverUrl"
              v-if="!toShowCover"
            ></OSSUpload>
            <el-button type="text" style="line-height:20px;margin-left:10px;color:#FF1A1A;" v-if="this.createData.coverUrl"
            @click="deltetCode">删除</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div class="upload_tips" v-if="activeType == '3'">照片格式为jpg或png，大小为10KB~10MB</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="btnCloseCreateClick">取消</el-button>
        <el-button type="primary" @click="btnDoneCreateClick">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixins from "./Mixins";
import OSSUpload from "@/components/OSSUpload";
export default {
  components: { OSSUpload },
  mixins: [mixins],
  data() {
    var validateTel = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入联系方式"));
      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    var validateTelA = (rule, value, callback) => {
      if (value == "") {
        callback();
      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        callback(new Error("请输入有效的企业微信号"));
      } else {
        callback();
      }
    };
    return {
      createRules: {
        unitId: [
          {
            required: true,
            message: "请选择单位",
            trigger: "change",
          },
        ],
        nick: [
          { required: true, message: "请输入使用者", trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "请输入2-30位的使用者",
            trigger: "blur",
          },
        ],
        tel: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { validator: validateTel, trigger: "blur" },
        ],
        enterpriseMobile: [
          { validator: validateTelA, trigger: "blur" },
        ],
      },
      editRules: {
        nick: [
          { required: true, message: "请输入使用者", trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "请输入2-30位的使用者",
            trigger: "blur",
          },
        ],
        tel: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { validator: validateTel, trigger: "blur" },
        ],
      },
      toShowCover: true,
    };
  },
  computed: {
    showCreateDialog: {
      get() {
        return this.Operation.showCreateDialog;
      },
      set(v) {
        this.SETOPTIONS({
          showCreateDialog: v,
        });
      },
    },
    activeType: {
      get() {
        return this.Operation.activeType;
      },
      set(v) {
        this.SETOPTIONS({
          activeType: v,
        });
      },
    },
    createData() {
      return this.Operation.createData;
    },
    createDialogTitle() {
      if (this.createData.isReuse) {
        return "解绑启用";
      } else if (this.createData.id) {
        return "编辑帐号";
      } else {
        return "新建帐号";
      }
    },
    resetPwd() {
      if (this.createData.resetPwd) {
        return "密码已重置";
      } else {
        return "******";
      }
    },
    arrUnitForCreate() {
      return this.Operation.arrUnitForCreate;
    },
    activeTabId() {
      return this.Operation.activeTabId;
    },
    activeTabLabel() {
      return this.Operation.activeTabLabel;
    },
    pageData() {
      return this.Operation.pageData;
    },
  },
  watch: {
    showCreateDialog(v) {
      if (v) {
        if (this.$refs.formCreateAccount) {
          this.$nextTick(() => {
            this.$refs.formCreateAccount.clearValidate();
          });
        }
      }
    },
  },
  methods: {
    //上传
    coverFileInfo(file) {
      console.log(file);
      this.createData.coverUrl = file.url;
      this.toShowCover = !this.toShowCover;
      console.log(this.createData.coverUrl);
    },
    deltetCode() {
      this.createData.coverUrl = ''
      this.toShowCover = !this.toShowCover;
    },
    handleDialogClose() {
      this.showCreateDialog = false;
      if (this.$refs.formCreateAccount) {
        this.$refs.formCreateAccount.clearValidate();
      }
    },
    btnCloseCreateClick() {
      this.handleDialogClose();
    },
    btbResetPwdClick() {
      this.createData.resetPwd = true;
    },
    btnDoneCreateClick() {
      this.$refs.formCreateAccount.validate(async (result) => {
        if (result) {
          if(this.createData.enterpriseMobile != '' && this.createData.coverUrl == ''){
            this.$message.error("请上传企业微信二维码图片");
            return
          }else if(this.createData.enterpriseMobile == '' && this.createData.coverUrl != ''){
            this.$message.error("请填写企业微信号");
            return
          }
          if (this.createData.id) {
            let params = {
              id: this.createData.id,
              unitId: this.createData.unitId,
              roleId: this.activeTabId,
              nick: this.createData.nick,
              tel: this.createData.tel,
              resetPwd: this.createData.resetPwd,
            };
            if(this.createData.enterpriseMobile != '' && this.createData.coverUrl != ''){
              params.enterpriseMobile = this.createData.enterpriseMobile;
              params.enterpriseCardUrl = this.createData.coverUrl;
            }
            if (this.createData.isReuse) {
              params.resetUsable = true;
            }
            let success = await this.createOrEditAccount_A(params);
            if (success) {
              this.showCreateDrawer = false;
              this.SETOPTIONS({
                showCreateDialog: false,
              });
              this.getTableList_A();
              this.$Message.success("操作成功");
            }
          } else {
            let params = {
              unitId: this.createData.unitId,
              roleId: this.activeTabId,
              nick: this.createData.nick,
              tel: this.createData.tel,
            };
            if(this.createData.enterpriseMobile != '' && this.createData.coverUrl != ''){
              params.enterpriseMobile = this.createData.enterpriseMobile;
              params.enterpriseCardUrl = this.createData.coverUrl;
            }
            let success = await this.createOrEditAccount_A(params);
            if (success) {
              this.showCreateDrawer = false;
              this.SETOPTIONS({
                pageData: {
                  page: 1,
                  size: this.pageData.size,
                  total: 0,
                },
                showCreateDialog: false,
              });
              this.getTableList_A();
              this.$Message.success("新建成功");
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.page_account_components.partI {
  .pms_name {
    width: 220px;
    line-height: 20px;
    padding: 10px 0;
    color: #000;
  }

  .reset_input {
    width: 110px;
  }

  .reset_btn {
    width: 90px;
    margin-left: 16px;
    padding: 0;
    height: 40px;
  }

  .search_item_a >>>.el-form-item__label {
    color: #040300;
  }
}
</style>

<style lang="stylus" >
.cover_upload_area_b {
  height: 97px;
  display: flex;
  flex-direction: row;
  .cover {
    width: 72px;
    height: 96px;
    display: block;
  }
}

.cover_upload_area_b .coverUrlBorder {
  .el-upload {
    border: 0;

    img {
      width: 171px;
      height: 228px;
    }
  }
}

.cover_upload_area_b .coverUrlBorder {
  .el-upload {
    border: 0;
    cursor: not-allowed;

    img {
      width: 171px;
      height: 228px;
    }
  }
}

.cover_upload_area_b .avatar-uploader {
  width: 220px !important;
  height: 97px !important;

  .el-upload {
    position: relative;
    // width: 220px;
    height: 97px;
    border: 1px dashed #D9D9D9;
    border-radius: 2px;
  }

  .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 220px;
    height: 97px;
    text-align: center;

    img {
      position: absolute;
      left: 85px;
      top: 10px;
      width: 50px;
      height: 50px;
    }

    p {
      position: absolute;
      left: 86px;
      top: 70px;
      font-size: 12px;
      font-weight: 400;
      color: #B7B7B7;
      height: 17px;
      line-height: 17px;

      span {
        color: #3A81FF;
      }
    }
  }

  .avatar {
    width: 220px;
    height: 97px;
    display: block;
    overflow: hidden;
    object-fit: contain;
  }

  .cover {
    width: 72px;
    height: 96px;
    display: block;
  }
}

.upload_tips {
  font-size: 12px;
  color: #FF1A1A;
  line-height: 17px;
  text-align: center;
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/PartI/OperationAccount/components/accountComponents.vue